import ApplicationController from "application_controller.js";

//* Goes to a URL when the element is clicked. Use it on a button that acts as a link,
//* next to a <noscript> link for visitors without JavaScript. Turbo visits the URL,
//* or set the turbo value to false for a full page load (a PDF or an external site).
//*   <button data-controller="visit" data-visit-url-value="/contact" data-action="visit#go">Contact</button>
export default class extends ApplicationController {
  debug = false;

  static values = {
    url: String,
    turbo: { type: Boolean, default: true },
  };

  go() {
    this.log_function("go", this.urlValue);

    if (this.turboValue) {
      window.Turbo.visit(this.urlValue);
    } else {
      window.location.href = this.urlValue;
    }
  }
}
